import { I18n } from '@affine/i18n';
import { NotificationProvider } from '@blocksuite/affine/shared/services';
import type { EditorHost } from '@blocksuite/affine/std';

/** Starts an AI action from an editor control; a failure is shown to the user instead of being dropped. */
export function runAIAction(
  host: EditorHost,
  action: () => Promise<unknown>
): void {
  action().catch((error: unknown) => {
    console.error(error);
    host.std
      .getOptional(NotificationProvider)
      ?.toast(I18n.t('com.streamlain.ai.action-failed'));
  });
}
